import React from 'react';
import { Box, TextField } from '@mui/material';
import ChampionshipInvitationPreview from './ChampionshipInvitationPreview';

export default function InvitationMessageEditor({
  qualifierMessage,
  onQualifierMessageChange,
  runnersUpMessage,
  onRunnersUpMessageChange,
  level,
  qualifierPreview,
  runnersUpPreview,
}) {
  return (
    <>
      <TextField
        fullWidth
        multiline
        minRows={4}
        label="Qualifier invitation message"
        value={qualifierMessage}
        onChange={(e) => onQualifierMessageChange(e.target.value)}
        helperText="Shown to the top 12 qualifiers who need to accept or decline. Paste a URL or use [link text](https://example.com)."
        sx={{ mb: 2 }}
      />
      <Box sx={{ mb: 3 }}>
        <ChampionshipInvitationPreview
          variant="qualifier"
          level={level}
          skaterName={qualifierPreview.skaterName}
          rank={qualifierPreview.rank}
          totalPoints={qualifierPreview.totalPoints}
          message={qualifierMessage}
        />
      </Box>
      <TextField
        fullWidth
        multiline
        minRows={4}
        label="Runner-up / waitlist message"
        value={runnersUpMessage}
        onChange={(e) => onRunnersUpMessageChange(e.target.value)}
        helperText="Shown to runners-up on the waitlist. Paste a URL or use [link text](https://example.com)."
        sx={{ mb: 2 }}
      />
      <Box sx={{ mb: 3 }}>
        <ChampionshipInvitationPreview
          variant="waitlist"
          level={level}
          skaterName={runnersUpPreview.skaterName}
          rank={runnersUpPreview.rank}
          totalPoints={runnersUpPreview.totalPoints}
          message={runnersUpMessage}
        />
      </Box>
    </>
  );
}
